import type { IdentifierModel, IdentifierValueModel, UUID } from "@overmap-ai/common"

import { getIdentifierCsvColumnHeader } from "../../utils"
import type { CSVColumnDef } from "../typings"

export const getCSVColumnDefOfIdentifier = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifier: TIdentifier,
	getIdentifierValue: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | undefined,
): CSVColumnDef<TData> => {
	return {
		id: identifier.uuid,
		header: getIdentifierCsvColumnHeader(identifier),
		accessorFn: (data: TData) => getIdentifierValue(identifier)(data),
	}
}

export const getCSVColumnDefsOfIdentifiers = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifiers: TIdentifier[],
	getIdentifierValue: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | undefined,
): CSVColumnDef<TData>[] => {
	return identifiers.map((identifier) => getCSVColumnDefOfIdentifier(identifier, getIdentifierValue))
}
